import { AuditLogsPage } from '@hq/sys-admin';
import { hq } from '../session';

/**
 * 审计日志（运营端只读，门禁 sys:audit:view）。
 * 页面实现收敛在 `@hq/sys-admin`，本端关闭租户维度（凭令牌自动收口到本租户），但保留可举证导出。
 */
export default function AuditLogs() {
  return <AuditLogsPage hq={hq} />;
}
